export const ACTIVE = 'active';
export const UNREAD = 'unread';
export const ARCHIVED = 'archived';

export const ACTIVE_TEXT = 'Active Conversations';
export const UNREAD_TEXT = 'Unread Conversations';
export const ARCHIVED_TEXT = 'Archived Conversations';

function getTextByKey(key) {
    switch (key) {
        case ACTIVE:
            return ACTIVE_TEXT;
        case UNREAD:
            return UNREAD_TEXT;
        case ARCHIVED:
            return ARCHIVED_TEXT;
        default:
            return ''; // Handle the case where the baseValue is not found
    }
}

export {getTextByKey}
